import React from "react";
import Slider from "react-slick";

// ✅ SAME imports as OttsliderNew
import App18 from "../images/PLAYBOXTV (2).png";
import App3 from "../images/new_Jiohotstar.jpeg";
import App4 from "../images/new_Sonyliv.jpeg";
// import App5 from "../images/new_Zee5.jpeg";
import App6 from "../images/new_Chaupal.jpeg";
import App7 from "../images/new_fancode.jpeg";
import App9 from "../images/new_stage.jpeg";
import App16 from "../images/new_discovery.jpeg";
import App8 from "../images/OMTV.png";
import App20 from "../images/chanajor.png";
import App10 from "../images/new_Sheemaro.webp";
import App11 from "../images/KANCHA.png";
import App12 from "../images/ITAP.png";
import App13 from "../images/DANGAL.png";
import App14 from "../images/WAVES.png";
import App22 from "../images/travel.png";
import App24 from "../images/etv.png";
import App25 from "../images/FW ott logo.png";
import App15 from "../images/new_shortstv.jpeg";
import App99 from "../images/RUnn.png";
import App89 from "../images/new_Hungama_Paly.png";

export const Ottslider = () => {
  const settings2 = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 300,
  };

  // ✅ SAME apps list
  const apps = [
    { img: App25, key: "FW ott logo" },
    { img: App18, key: "playbox" },
    { img: App3, key: "jiohotstar" },
    { img: App4, key: "sony" },
    // { img: App5, key: "zee" },
    { img: App6, key: "chaupal" },
    { img: App7, key: "fancode" },
    { img: App16, key: "discovery" },
    { img: App20, key: "chanajor" },
    { img: App10, key: "sheemaro" },
    { img: App9, key: "stage" },
    { img: App8, key: "omtv" },
    { img: App11, key: "kancha" },
    { img: App12, key: "itap" },
    { img: App13, key: "dangal" },
    { img: App14, key: "waves" },
    { img: App15, key: "new_shortstv" },
    { img: App22, key: "travel" },
    { img: App24, key: "etv" },
    { img: App99, key: "RUnn" },
    { img: App89, key: "hungama" },
  ];

  // ✅ Apply 499 filter
  const filteredApps = apps.filter(
    (app) =>
      app.key !== "discovery" && app.key !== "waves" && app.key !== "etv",
  );

  return (
    <div className="ottslider">
      <Slider {...settings2}>
        {filteredApps.map((app, index) => (
          <div key={index}>
            <div className="ottimg">
              <img src={app.img} alt={app.key} />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
